"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TutorialGallery;
require("core-js/modules/web.dom-collections.iterator.js");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("swiper/react");
var _modules = require("swiper/modules");
require("swiper/css");
require("swiper/css/navigation");
require("swiper/css/pagination");
require("../../css/swiper.css");
var _leftArrow = _interopRequireDefault(require("../../assets/images/left-arrow.svg"));
var _rightArrow = _interopRequireDefault(require("../../assets/images/right-arrow.svg"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7; // Import Swiper React components
// Import Swiper styles
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function TutorialGallery(_ref) {
  let {
    style,
    cards = []
  } = _ref;
  const [currentIndex, setCurrentIndex] = (0, _react.useState)(1);
  const [totalIndex, setTotalIndex] = (0, _react.useState)(1);
  return /*#__PURE__*/_react.default.createElement(MainContainer, {
    className: "light-stick-tutorial-gallery",
    style: style
  }, /*#__PURE__*/_react.default.createElement(SwiperContainer, null, /*#__PURE__*/_react.default.createElement(_react2.Swiper, {
    modules: [_modules.Navigation, _modules.Pagination],
    slidesPerView: "auto",
    centeredSlides: true,
    breakpointsBase: "window",
    navigation: {
      prevEl: "#tutorial-prev-btn",
      nextEl: "#tutorial-next-btn"
    },
    pagination: {
      clickable: true,
      el: "#swiper-bullet"
    },
    onActiveIndexChange: swiper => {
      setCurrentIndex(swiper.activeIndex + 1);
    },
    onUpdate: swiper => {
      setTotalIndex(swiper.slides.length);
    },
    slideToClickedSlide: true,
    breakpoints: {
      375: {
        spaceBetween: 0
      },
      768: {
        spaceBetween: 30
      }
    }
  }, cards.map((card, idx) => {
    return /*#__PURE__*/_react.default.createElement(StyledSwiperSlide, {
      style: currentIndex == idx + 1 ? {
        transform: "scale(1)"
      } : {
        transform: "scale(0.833)"
      }
    }, /*#__PURE__*/_react.default.createElement(StyledSlideContent, null, card));
  }))), /*#__PURE__*/_react.default.createElement(StyledBulletContainer, {
    id: "swiper-bullet"
  }), /*#__PURE__*/_react.default.createElement(StyledNavContainer, {
    id: "swiper-nav"
  }, /*#__PURE__*/_react.default.createElement("div", {
    id: "tutorial-prev-btn"
  }, /*#__PURE__*/_react.default.createElement(StyledNavBtn, {
    src: _leftArrow.default,
    style: currentIndex == 1 ? {
      opacity: 0
    } : {
      opacity: 1
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: "30%"
    }
  }, currentIndex, " / ", totalIndex), /*#__PURE__*/_react.default.createElement("div", {
    id: "tutorial-next-btn"
  }, /*#__PURE__*/_react.default.createElement(StyledNavBtn, {
    src: _rightArrow.default,
    style: currentIndex == totalIndex ? {
      opacity: 0
    } : {
      opacity: 1
    }
  }))));
}
const MainContainer = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n"])));
const SwiperContainer = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
const StyledSwiperSlide = (0, _styledComponents.default)(_react2.SwiperSlide)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  width: 300px;\n\n  @media (min-width: 768px) {\n    width: 360px;\n  }\n"])));
const StyledSlideContent = _styledComponents.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  width: 300px;\n\n  @media (min-width: 768px) {\n    width: 360px;\n  }\n"])));
const StyledBulletContainer = _styledComponents.default.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 16px;\n"])));
const StyledNavContainer = _styledComponents.default.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  margin-top: 24px;\n  width: 300px;\n  align-self: center;\n  align-items: center;\n"])));
const StyledNavBtn = _styledComponents.default.img(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  cursor: pointer;\n"])));